import React, { memo } from "react";
import DataTable from "react-data-table-component";
import Pagination from "./Pagination";
import styles from "./Table.module.scss";
import { combineClasses } from "utils/utils";
import TableSkeleton from "./TableSkeleton";

const Table = (props) => {
  return (
    <div className={styles.tableWrap}>
      <DataTable
        {...props}
        pagination={false}
        progressPending={props?.progressPending}
        progressComponent={<TableSkeleton columns={props.columns} />}
        noDataComponent={
          <p className={styles.noData}>There are no records to display</p>
        }
        columns={props?.columns}
        className={combineClasses(styles.table, props.className || "")}
        fixedHeader={true}
        responsive
      />
      {props?.paginationProps?.isPagination && (
        <Pagination {...props?.paginationProps} />
      )}
    </div>
  );
};

export default memo(Table);
